// eslint-disable-next-line import/prefer-default-export
export const objectMap = (obj, fn) => Object.fromEntries(
    Object.entries(obj).map(
        ([k, v], i) => [k, fn(v, k, i)],
    ),
)
